import React from 'react';
import { Modal } from '../styled-primitives';
import { fjModalSizes } from '../primitives/fj-modal';

type InfoEotModalProps = {
  device: Device;
  okCallback: () => void;
  productName: string;
  defaultDays: number;
  isFlowJo: boolean;
};

export const InfoEotModal: React.FC<InfoEotModalProps> = ({
  device,
  okCallback,
  productName,
  defaultDays,
  isFlowJo,
}: InfoEotModalProps): React.ReactElement<InfoEotModalProps> => {
  return (
    <Modal
      data-test="info-eot-modal"
      accept={{
        text: 'OK',
        callback: okCallback,
      }}
      title="Syncing an Extended Offline Token"
      size={fjModalSizes.LG}
      showX
      onClickX={okCallback}
    >
      <p style={{ marginBottom: '0.75rem' }}>
        While still connected to a network, login to the {productName} Application on {device.name}
      </p>
      <p style={{ marginBottom: '0.75rem' }}>
        Once you sign in successfully, you may disconnect from the network and authorize{' '}
        {productName} for the next {defaultDays} days.
      </p>
      <p style={{ marginBottom: '0.75rem' }}>
        The Extended Offline Token will be automatically synced to {device.name} when the device
        connects to the network, or you can transfer the EOT manually by clicking the{' '}
        <strong>Export Offline Token</strong> button from the Manage Devices modal.
      </p>
      <p style={{ marginBottom: '0.75rem' }}>
        This EOT has already been initiated. Delay in syncing the EOT to the device does not change
        the expiration date.
      </p>
      <p style={{ marginBottom: '0.75rem' }}>
        For more information, visit{' '}
        <a
          href={
            isFlowJo
              ? 'https://www.flowjo.com/docs/bdaccessportal/extended-offline-tokens'
              : 'https://www.flowjo.com/docs/bdaccessportal/extended-offline-tokens-copy'
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          {isFlowJo
            ? 'https://www.flowjo.com/docs/bdaccessportal/extended-offline-tokens'
            : 'https://www.flowjo.com/docs/bdaccessportal/extended-offline-tokens-copy'}
        </a>
      </p>
    </Modal>
  );
};
